import { useParams } from '@tanstack/react-router'

import { CalloutLogWorkScreen } from '@/screens/CalloutLogWorkScreen'
import { ServicePageShell } from '@/screens/ServicePageShell'
import { useCalloutLogWork } from '@/screens/useCalloutLogWork'

export function CalloutLogWorkScreenContainer() {
  const serviceId = useParams({ from: '/callouts/$id/logs', select: (p) => p.id })
  const logWork = useCalloutLogWork(serviceId)

  if (logWork.kind === 'loading') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-container mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Callout Log Work</h1>
          <p className="text-sm text-slate-600">Loading callout…</p>
        </main>
      </div>
    )
  }

  if (logWork.kind === 'error') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-container mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Callout Log Work</h1>
          <p className="text-sm text-slate-600">Unable to load callout right now.</p>
        </main>
      </div>
    )
  }

  if (logWork.kind === 'not_found') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-container mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Callout Log Work</h1>
          <p className="text-sm text-slate-600">
            Callout not found. Check the link or return to the bookings page.
          </p>
        </main>
      </div>
    )
  }

  const displayId = logWork.screenProps.publicId ?? logWork.screenProps.id

  return (
    <ServicePageShell
      serviceTypeLabel="Callout"
      serviceId={displayId}
      customerName={logWork.screenProps.customerName}
      customerId={logWork.screenProps.customerId}
      customerPublicId={logWork.screenProps.customerPublicId}
      scheduledAtLabel={logWork.screenProps.scheduledAt}
      initialIssue={logWork.screenProps.issueSummary}
      activeTab="logs"
      basePath="/callouts/$id"
      currentStatus={logWork.screenProps.status}
      statusChanges={logWork.screenProps.statusChanges}
      getAuthorDisplayName={logWork.screenProps.getAuthorDisplayName}
    >
      <CalloutLogWorkScreen {...logWork.screenProps} showHeader={false} />
    </ServicePageShell>
  )
}
